import { cn } from 'noddi-ui-common';

interface Props {
  slug: string;
  className?: string;
}

export const PrettySlug = ({ slug, className }: Props) => (
  <span className={cn('font-mono tracking-wider', className)}>{slug.toUpperCase()}</span>
);
